import { forwardRef } from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import MDInputRoot from "components/MDInput/MDInputRoot";

const MDInput = forwardRef(
  (
    {
      error,
      success,
      disabled,
      customStyle,
      isPassword,
      labelType = "sticky",
      labelText,
      labelStyle,
      helperText,
      required,
      startAdornment,
      endAdornment,
      autoComplete,
      ...rest
    },
    ref
  ) => (
    <>
      {labelType === "non-sticky" && labelText && (
        <Typography
          className="label"
          variant="caption"
          style={{ marginBottom: 4, display: "block", ...labelStyle }}
        >
          {labelText}
          {required && !error && <sup>*</sup>}
          {error && <sup style={{ color: "red", marginLeft: 4 }}>*</sup>}
        </Typography>
      )}
      <MDInputRoot
        {...rest}
        ref={ref}
        disabled={disabled}
        ownerState={{
          error,
          success,
          disabled,
          customStyle,
          isPassword,
          labelType,
        }}
        autoComplete={autoComplete}
        label={labelType === "sticky" ? labelText : ""}
        InputLabelProps={
          labelType === "non-sticky"
            ? { style: { display: "none" } }
            : undefined
        }
        InputProps={{
          startAdornment,
          endAdornment,
        }}
        helperText={
          labelType === "sticky" && error
            ? helperText || <sup style={{ color: "red" }}>*</sup>
            : helperText
        }
        required={required}
      />
    </>
  )
);

// Setting default values for the props of MDInput
MDInput.defaultProps = {
  error: false,
  success: false,
  disabled: false,
  customStyle: {},
  isPassword: false,
  labelType: "sticky",
  labelText: "",
  labelStyle: {},
  helperText: "",
  required: false,
  startAdornment: null,
  endAdornment: null,
  autoComplete: "off",
};

// Typechecking props for the MDInput
MDInput.propTypes = {
  error: PropTypes.bool,
  success: PropTypes.bool,
  disabled: PropTypes.bool,
  customStyle: PropTypes.object,
  isPassword: PropTypes.bool,
  labelType: PropTypes.oneOf(["sticky", "non-sticky"]),
  labelText: PropTypes.string,
  labelStyle: PropTypes.object,
  helperText: PropTypes.node,
  required: PropTypes.bool,
  startAdornment: PropTypes.node,
  endAdornment: PropTypes.node,
  autoComplete: PropTypes.oneOf(["on", "off", "new-password"]),
};

export default MDInput;
